//https://www.skyharbor.com/api/default/listitems?$filter=ParentId%20eq%20fa7903a1-0c49-6a75-a385-ff1400f4265d

import React from 'react';
import ReactDOM from 'react-dom';
import Card from '../common/card/card';
import { createElementFromHTML } from '../../helpers/helpers'

interface ProviderState {
    isSpanish: boolean;
    providers: ProviderRow[][]
}
interface ProviderRow {
    cn: string | null
    con: string | null
    email: string | null
    website: string | null
    ls: string | null
    nr: string | null
    fq: string | null
}
class GTProviderElement extends React.Component<{}, ProviderState> {
    constructor(props: any) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';
        this.state = { isSpanish, providers: [] };

        fetch(`/api/default/listitems?$filter=ParentId%20eq%20fa7903a1-0c49-6a75-a385-ff1400f4265d&$orderby=Ordinal&sf_culture=${this.state.isSpanish ? 'es' : 'en'}`)
            .then((req) => req.json())
            .then(items => items.value)
            .then(items => items.map((i: any) => {
                const tempElements = createElementFromHTML(i.Content);
                let returnArr: ProviderRow[] = [];
                for (let iii = 0; iii < tempElements.length; iii++) {
                    if (tempElements.item(iii).nodeName === 'TABLE') {
                        tempElements.item(iii).childNodes.item(0).childNodes.forEach(element => {

                            if (element.nodeName === 'TR') {
                                const ee = element.childNodes;

                                returnArr.push({
                                    cn: ee.item(0).textContent,
                                    con: this.addDashes(ee.item(1).textContent),
                                    email: ee.item(2).textContent,
                                    website: ee.item(3).textContent,
                                    ls: ee.item(4).textContent,
                                    nr: ee.item(5).textContent,
                                    fq: ee.item(6).textContent,

                                });
                            }
                        })

                    }
                }
                let rrArr: ProviderRow[][] = [];
                let tLength = returnArr.length / 3;
                let l = returnArr.length;
                rrArr.push(returnArr.splice(0, tLength+1))
                rrArr.push(returnArr.splice(0, tLength))
                rrArr.push(returnArr.splice(0, returnArr.length))
                this.setState(Object.assign(this.state, { providers: rrArr }))
            }))
    }
    addDashes = (source: string | null): string | null => {
        if (source === null) return source;
        if (source.length === 10) {
            const p1 = source.substr(0, 3);
            const p2 = source.substr(3, 3);
            const p3 = source.substr(6, source.length);

            return `${p1}-${p2}-${p3}`
        }
        return source
    }

    findAchor = (elem: any): any => {
        if (elem.childNodes.length === 0) {
            return null
        }
        if (elem.childNodes[0].nodeName.toUpperCase() === 'A') {
            return elem.childNodes[0]
        }
        return this.findAchor(elem.childNodes[0]);
    };

    render() {
        return (

            <div className="row">
                {this.state.providers.map((pa: ProviderRow[], tidx: number) =>

                    <div className="col-sm-12 col-md-6 col-lg-4">
                        {pa.map((pr: ProviderRow, idx: number) =>

                            idx == 0 ? <div key={0}></div> :
                                <Card className={tidx === 0 ? "col-sm-12 p-1" : tidx === 1 ? "col-sm-12 py-1" : "col-sm-12 p-1"} title={pr.cn} key={idx + pr.cn!}>
                                    {pr.con!.charCodeAt(0) != 160 ? <div className="col-12">Phone : <a href={'tel:' + pr.con}>{pr.con}</a></div> : null}
                                    {pr.email!.charCodeAt(0) != 160 ? <div className="col-12">Email : <a href={'mailto:' + pr.email!}>{pr.email}</a> </div> : null}
                                    {pr.website!.charCodeAt(0) != 160 ? <div className="col-12">Website : <a href={'https://' + pr.website!}>{pr.website}</a></div> : null}
                                    {pr.ls!.charCodeAt(0) != 160 ? <div className="col-12">Locations Served : {pr.ls}</div> : null}
                                    {pr.fq!.charCodeAt(0) != 160 ? <div className="col-12">Rates : {pr.fq}</div> : null}
                                    {pr.nr!.charCodeAt(0) != 160 ? <div className="col-12">Notice : {pr.nr}</div> : null}
                                </Card>

                        )}
                    </div>
                )}




            </div>
        )
    }
}


let domContainer = document.querySelector('#gtproviderelement');
if (!(domContainer === undefined || domContainer === null)) ReactDOM.render(<GTProviderElement />, domContainer);
